var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "captcha-align-" + _vm.localAlign + " captcha" }, [
    !_vm.editingFieldLabel && _vm.showLabel
      ? _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "captcha" },
            on: { click: _vm.focusFieldLabel },
          },
          [
            _vm._v("\n        " + _vm._s(_vm.displayFieldLabel) + "\n        "),
            _vm.isRequired
              ? _c("span", { staticClass: "required-indicator" }, [_vm._v("*")])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingFieldLabel
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localFieldLabel,
              expression: "localFieldLabel",
            },
          ],
          ref: "fieldLabelInput",
          staticClass: "field-label-input",
          attrs: { type: "text", placeholder: "Güvenlik Doğrulaması" },
          domProps: { value: _vm.localFieldLabel },
          on: {
            blur: _vm.stopEditingFieldLabel,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingFieldLabel.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldLabel = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "captcha-container" }, [
      _c("div", { staticClass: "captcha-preview" }, [
        _c("canvas", {
          ref: "captchaCanvas",
          staticClass: "captcha-canvas",
          attrs: { width: _vm.captchaWidth, height: _vm.captchaHeight },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "captcha-input-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.captchaInput,
              expression: "captchaInput",
            },
          ],
          staticClass: "captcha-input",
          attrs: {
            type: "text",
            placeholder: _vm.placeholder || "Yukarıdaki kodu girin",
            readonly: "",
          },
          domProps: { value: _vm.captchaInput },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.captchaInput = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "refresh-icon-button",
            attrs: { type: "button" },
            on: { click: _vm.refreshCaptcha },
          },
          [_c("md-icon", [_vm._v("refresh")])],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }